import clsx from 'clsx';
import { useCallback } from 'react';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { gtmPushTopNavigationLevel } from 'modules/gtm/modules/sections/navigation/navigation';
import { usePathname } from 'modules/next/hooks';
import { NavigationItem } from 'modules/stroyblok/types';
import { Regex } from 'src/client/modules/validation';
import styles from './ItemLevel1.module.css';

export const ItemLevel1 = ({
  item,
  setVisibleItem,
}: {
  item: NavigationItem;
  setVisibleItem: () => void;
}) => {
  const pathname = usePathname();
  const [level1] = pathname.split('/').filter(Boolean);
  const isCurrent = level1 === item.url?.cached_url.replace(Regex.slashes, '');
  const pushNavigationEvent = useCallback((title: string | undefined) => {
    gtmPushTopNavigationLevel(title || 'Unknown');
  }, []);

  const handleLinkClick = useCallback(() => {
    pushNavigationEvent(item?.title);
  }, [item?.title, pushNavigationEvent]);

  const handleButtonClick = useCallback(() => {
    pushNavigationEvent(item?.title);
    setVisibleItem();
  }, [item?.title, setVisibleItem, pushNavigationEvent]);

  if (!item.flyoutColumns?.length && item.url) {
    return (
      <StoryBlokLink
        className={clsx(styles.root, isCurrent && styles.current)}
        link={item.url}
        onClick={handleLinkClick}
      >
        {item?.title}
      </StoryBlokLink>
    );
  }

  return (
    <button
      className={clsx(styles.root, isCurrent && styles.current)}
      type="button"
      onClick={handleButtonClick}
    >
      {item?.title}
    </button>
  );
};
